<div class="p-grid">
  <div class="p-col-12">
    <div [ngClass]="showCardBlock ? 'card' : ''">
      <ng-content></ng-content>
    </div>
  </div>
</div>